import { twMerge } from 'tailwind-merge'

interface BadgeProps {
  text: string
  classNames?: string
}

const Badge = ({ text, classNames }: BadgeProps) => {
  return (
    <div
      className={twMerge(
        `text-text-tertiary whitespace-nowrap rounded-md px-1 py-[1px] text-xs`,
        classNames,
      )}
    >
      {text}
    </div>
  )
}

export default Badge
